import { ChevronDown } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';
import { PrimaryColor, SidelyBlack } from './Utils';

const OpenWrapper = styled.div<{ isOpen?: boolean, horizontal?: boolean }>`
	flex-shrink: 0;
	position: relative;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transform: rotate(${p => p.isOpen ? (p.horizontal ? '-90deg' : '180deg') : (p.horizontal ? '90deg' : '0deg')});
	transition: 0.25s;
`;

type OpenProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'color'> & {
	isOpen?: boolean,
	size?: number,
	width?: number,
	height?: number,
	color?: 'blue' | 'white' | 'black',
	horizontal?: boolean
}

export function Open({ isOpen, size, width, height, color, horizontal, ...rest }: OpenProps): JSX.Element {
	const iconColor = color === 'blue' ? PrimaryColor : color === 'white' ? 'white' : SidelyBlack;
	return <OpenWrapper isOpen={isOpen} horizontal={horizontal} {...rest}>
		<ChevronDown viewBox='5 8 14 8' width={width ?? size ?? 15} height={height ?? size ?? 15} color={iconColor} />
	</OpenWrapper>;
}

const ToggleContainer = styled.div`
  padding: 11px 0px 11px 0px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: ${SidelyBlack};
`;

export function ButtonToggle(props: { title: string, alreadyTranslated?: boolean, isOpen: boolean, onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void }): JSX.Element {
	const { title, alreadyTranslated, isOpen } = props;
	return (
		<ToggleContainer
			onClick={props.onClick}
		>
			{alreadyTranslated ? title : <Translate id={title} />}
			<span style={{ float: 'right', marginRight: 20, position: 'relative', top: 4 }}>
				<Open
					isOpen={isOpen}
					size={11}
				/>
			</span>
		</ToggleContainer>
	);
}
